import { Component, OnInit, inject } from '@angular/core';
import { DataExchangeService } from '../../services/session/data-exchange.service';

@Component({
    selector: 'app-error-page',
    // standalone: true,
    // imports: [],
    templateUrl: './error-page.component.html',
    styleUrl: './error-page.component.css',
    //standalone: false
})
export class ErrorPageComponent  implements OnInit {

  public messageHeader!: string;
  public messageText!: string;

  isMessageShown: boolean = false;

  private readonly dataExchangeService = inject(DataExchangeService);

  ngOnInit() {
    this.messageHeader = this.dataExchangeService.getMessageHeader();
    this.messageHeader = this.messageHeader ? this.messageHeader : 'ACI Walletron';
    this.messageText = this.dataExchangeService.getMessageText();
    if (this.messageText) {
      this.isMessageShown = true;
    }
  }

  onClose() {
    window.open('','_parent','');
    window.close();
  }
}

